import useAxios from '@/hooks/useAxios'

const { get, post } = useAxios()

export const getStationRelevance = (params?: any) => get('/station/get_station_relevance', params)

export const getDeviceFuns = (params?: any) => get('/station/get_device_funs', params)

//  新增通讯日志
export const addCommLog = (params?: any) => post('/station/add_comm_log', params)

//  更新通讯日志
export const updateCommLog = (params?: any) => post('/station/update_comm_log', params)

//  场站分享
export const setStationShare = (params?: any) => post('/station/save_station_share', params)

//  删除场站
export const delStation = (params?: any) => post('/station/delete_station', params)

//  新增场站
export const addStation = (params?: any) => post('/station/add_station', params)

//  收藏场站
export const collectStation = (params?: any) => post('/station/collect_station', params)

//  编辑场站
export const editStation = (params?: any) => post('/station/edit_station', params)

//  设置场站费率
export const setStationTariff = (params?: any) => post('/station/set_station_tariff', params)

//  获取场站费率
export const getStationTariff = (params?: any) => get('/station/get_station_tariff', params)

//  设置企业
export const setEnterprise = (params?: any) => post('/station/set_enterprise', params)

//  获取场站分页
export const getStationPage = (params?: any) => get('/station/get_page', params)

//  获取场站合计
export const getStationCount = () => get('/station/get_count')
